//imports
import {
    JIRA_DETAILS_OPEN_MODAL,
    JIRA_SEARCH_DETAILS_REQUEST,
    JIRA_SEARCH_DETAILS_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    openModal: false,
    user: null,
    loading: false, 
    result: null,
    timeframe: null
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case JIRA_DETAILS_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, user: action.payload.user, timeframe: action.payload.range }

        case JIRA_SEARCH_DETAILS_REQUEST:
            return { ...state, loading: true }

        case JIRA_SEARCH_DETAILS_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "JIRA_DETAILS"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
